import { VStack } from '@chakra-ui/react';
import { useState } from 'react';
import ListenAudio from '../HelperComponents/ListenAudio';
import TagOption from './TagOption';
import useMediaOptions from './useMediaOptions';

const ListenWithText = ({
  exercise,
  setSelectedAnswer,
  disabled,
  ...props
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const { 
    mediaList,
    currentlyPlaying,
    onAudioPlay,
    stopAllAudio
  } = useMediaOptions({ 
    exercise,
    hasAudio: true 
  });

  const handleAnswerClick = (option) => {
    if (disabled) return;
    
    setSelectedOption(option);
    setSelectedAnswer(option);
  };

  return (
    <VStack
      justifyContent="center"
      alignItems="center"
      spacing={[2, 2, 5]}
      data-testid={props['data-testid']}
      width="100%"
    >
      {(exercise?.audio || exercise?.slowAudio) && (
        <ListenAudio 
          data={exercise} 
          audioControl={{
            currentlyPlaying,
            onAudioPlay,
            stopAllAudio
          }}
        />
      )}
      
      <VStack 
        textAlign="center"
        spacing={3}
        width="100%"
        maxWidth="400px"
      >
        {mediaList.map((option, i) => (
          option?.value && (
            <TagOption
              key={`${option.key}-${i}`}
              option={option}
              disabled={disabled}
              onClick={() => handleAnswerClick(option)}
              width={['300px', '350px']}
              boxShadow={
                option === selectedOption 
                  ? '0 0 0 2px #2367f0' 
                  : '0 0 0 1px #707070'
              }
              transition="all 0.2s ease"
            />
          )
        ))}
      </VStack>
    </VStack>
  );
};

export default ListenWithText;